import React from "react";
import { Link } from "react-router-dom";
import { StatusIndicator } from "@amzn/awsui-components-react-v3";

export interface JobStatusProps {
  state: string;
  onRetry: () => void;
}

export enum JobState {
  FAILED = "FAILED",
  NON_RECOVERABLE_FAILURE = "NON RECOVERABLE FAILURE",
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED",
}

export const JobStatus: React.FC<JobStatusProps> = ({
  state,
  onRetry,
}): JSX.Element => {
  const retry = (
    <Link to={"#"} onClick={onRetry}>
      Retry
    </Link>
  );
  switch (state) {
    case JobState.FAILED:
      return <StatusIndicator type="error">Error - {retry}</StatusIndicator>;
    case JobState.NON_RECOVERABLE_FAILURE:
      return <StatusIndicator type="error">Error</StatusIndicator>;
    case JobState.COMPLETED:
      return <StatusIndicator type="success">Success</StatusIndicator>;
    case JobState.CANCELED:
      return <StatusIndicator type="stopped">Stopped</StatusIndicator>;
    default:
      // the job is neither completed nor failed, so it's in some pending state
      return <StatusIndicator type="pending">Pending</StatusIndicator>;
  }
};

export default JobStatus;
